module.exports = __webpack_public_path__ + "img/message.a3479433.png";